module.exports = __webpack_public_path__ + "img/EG.f97b4539.svg";